import { lazy } from "react";
import { ROUTES } from "../constants/routes";
import PublicRoute from "../components/Auth/PublicRoute";
import ProtectedRoute from "../components/Auth/ProtectedRoute";

// Lazy load components for better performance
const SignInPage = lazy(() => import("../pages/Auth/SignInPage"));
const SignUpPage = lazy(() => import("../pages/Auth/SignUpPage"));
const ForgotPassword = lazy(() => import("../pages/Auth/ForgotPassword"));
const VerifyOTP = lazy(() => import("../pages/Auth/VerifyOTP"));
const ChangePassword = lazy(() => import("../pages/Auth/ChangePassword"));
const HomePage = lazy(() => import("../pages/Home/HomePage"));
const MinerInfo = lazy(() => import("../pages/Dashboard/MinerInfo"));
const MinerInfoSecond = lazy(
  () => import("../pages/Dashboard/MinerInfoSecond"),
);
const Contact = lazy(() => import("../pages/Support/Contact"));
const FAQs = lazy(() => import("../pages/Support/FAQs"));
const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
const MinerDetails = lazy(() => import("../pages/Dashboard/MinerDetails"));
const EarningHistory = lazy(() => import("../pages/Wallet/EarningHistory"));
const MyWallet = lazy(() => import("../pages/Wallet/MyWallet"));
const WithdrawHistory = lazy(() => import("../pages/Wallet/WithdrawHistory"));
const ReferralProgram = lazy(() => import("../pages/Home/ReferralProgram"));
const InvitationHistory = lazy(
  () => import("../pages/Wallet/InvetationHistory"),
);
const Setting = lazy(() => import("../pages/Dashboard/Setting"));
const CustomerSupport = lazy(() => import("../pages/Support/CustomerSupport"));
const TermsConditions = lazy(() => import("../pages/Legal/TermsConditions"));
const PrivacyPolicy = lazy(() => import("../pages/Legal/PrivacyPolicy"));

/**
 * Application Routes Configuration
 * Centralized route definitions using constants
 */
const routes = [
  // Auth Routes (Only accessible if NOT logged in)
  {
    path: ROUTES.ROOT,
    element: <HomePage />,
  },
  {
    path: ROUTES.SIGN_IN,
    element: (
      <PublicRoute>
        <SignInPage />
      </PublicRoute>
    ),
  },
  {
    path: ROUTES.SIGN_UP,
    element: (
      <PublicRoute>
        <SignUpPage />
      </PublicRoute>
    ),
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    element: (
      <PublicRoute>
        <ForgotPassword />
      </PublicRoute>
    ),
  },
  {
    path: ROUTES.VERIFY_OTP,
    element: (
      <PublicRoute>
        <VerifyOTP />
      </PublicRoute>
    ),
  },
  {
    path: ROUTES.CHANGE_PASSWORD,
    element: (
      <PublicRoute>
        <ChangePassword />
      </PublicRoute>
    ),
  },
  // Public Routes
  {
    path: ROUTES.HOME,
    element: <HomePage />,
  },
  {
    path: `${ROUTES.MINER_INFO}/:id`,
    element: <MinerInfo />,
  },
  {
    path: `${ROUTES.MINER_INFO_SECOND}/:id`,
    element: <MinerInfoSecond />,
  },
  {
    path: ROUTES.CONTACT,
    element: <Contact />,
  },
  {
    path: ROUTES.FAQS,
    element: <FAQs />,
  },
  {
    path: ROUTES.TERMS_CONDITIONS,
    element: <TermsConditions />,
  },
  {
    path: ROUTES.PRIVACY_POLICY,
    element: <PrivacyPolicy />,
  },
  // Dashboard Routes (Requires authentication)
  {
    path: ROUTES.DASHBOARD,
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MINER_DETAILS,
    element: (
      <ProtectedRoute>
        <MinerDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.EARNING_HISTORY,
    element: (
      <ProtectedRoute>
        <EarningHistory />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MY_WALLET,
    element: (
      <ProtectedRoute>
        <MyWallet />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.WITHDRAWAL_HISTORY,
    element: (
      <ProtectedRoute>
        <WithdrawHistory />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.REFERRAL_PROGRAM,
    element: (
      <ProtectedRoute>
        <ReferralProgram />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.INVITATION_HISTORY,
    element: (
      <ProtectedRoute>
        <InvitationHistory />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.SETTINGS,
    element: (
      <ProtectedRoute>
        <Setting />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.CUSTOMER_SUPPORT,
    element: (
      <ProtectedRoute>
        <CustomerSupport />
      </ProtectedRoute>
    ),
  },
];

export default routes;
